import React from "react";
import MenuSection from "../components/MenuSection";
import Sidebar from "../components/Sidebar";
import FacturacionMini from "../components/FacturacionMini";
import FooterMini from "../components/FooterMini";

const DashboardMini = () => {
  return (
    <>
      <FooterMini />
      <Sidebar />
      <FacturacionMini /> 
    </>
  );
};

export default DashboardMini;
